// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.brewcontrol_config_kind_enum */
var BrewcontrolConfigKindEnum;
(function (BrewcontrolConfigKindEnum) {
    BrewcontrolConfigKindEnum["devices"] = "devices";
    BrewcontrolConfigKindEnum["workspaces"] = "workspaces";
    BrewcontrolConfigKindEnum["wiring"] = "wiring";
    BrewcontrolConfigKindEnum["tuning"] = "tuning";
    BrewcontrolConfigKindEnum["calibration"] = "calibration";
})(BrewcontrolConfigKindEnum || (BrewcontrolConfigKindEnum = {}));
;
export default BrewcontrolConfigKindEnum;
/** Zod schema for brewcontrol_config_kind_enum */
export const brewcontrolConfigKindEnum = z.nativeEnum(BrewcontrolConfigKindEnum);
//# sourceMappingURL=BrewcontrolConfigKindEnum.js.map